import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Esriautocomplete from "../../../../../../../../../components/esriautocomplete";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateSearchFilters } from "../../../../../../../../../actions/search";
import "../../../../../../../../scss/../../scss/_searchFilters.scss";

const InputContainer = styled.div`
  width: 100%;
  .autocomp_wrapper {
    border: 1px solid #b9c8d1;
    .icon_search {
      display: none !important;
    }
    .rbt-aux {
      display: none;
    }
    input {
      font-size: 1rem !important;
    }
    .filters_chip_wrapper {
      align-items: center;
      span {
        font-size: 0.75rem;
      }
    }
  }
`;

const HeaderIdFromName = {
  City: "cities",
  "Zip Code": "zipCodes",
  Subdivision: "subdivisions",
  Address: "addresses",
};

function clearAutocompleteData(selectedOptions, criteria) {
  const { header, key: value } = selectedOptions[0];
  let headerId = HeaderIdFromName[header];
  if (!headerId) return criteria;
  let currentData = criteria[headerId] ?? [];

  const newData = Array.from(new Set([...currentData, value]));
  criteria[headerId] = newData;

  return criteria;
}

const InputSearch = ({ placeholder, searchConfig }) => {
  const defaultPropertyTypes = (searchConfig.PropertyType || {}).DefaultOptions;
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.search.filters);

  const handleAutoComplete = (data) => {
    if (!data && data.length) return;

    const criteria = clearAutocompleteData(data, { ...filters.Criteria });
    dispatch(updateSearchFilters({ ...filters, Criteria: criteria }));
  };

  return (
    <InputContainer>
      <Esriautocomplete
        showClearButton={false}
        className="search full-width"
        placeholder={placeholder}
        hideFocus={true}
        defaultPropertyTypes={defaultPropertyTypes}
        usePublicFetch={true}
        handleAutoComplete={handleAutoComplete}
        showHideFilterButton={false}
      />
    </InputContainer>
  );
};

InputSearch.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
};

InputSearch.defaultProps = {
  type: "text",
};
export default InputSearch;
